import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    web4open_api: '/web4open_api',
    marketInfo: '',
    menuActive: ''
  },
  mutations: {
    setMarketInfo(state, info) {
      state.marketInfo = info
      window.sessionStorage.setItem('marketInfo', JSON.stringify(info))
    },
    getMarketInfo(state) {
      var marketInfo = JSON.parse(window.sessionStorage.getItem('marketInfo'))
      if (marketInfo) {
        state.marketInfo = marketInfo
      }
    },
    setMenuActive(state, value) {
      state.menuActive = value
    }
  },
  actions: {},
  modules: {}
})
